<template>
  <el-dialog
    title="钻头出库"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="110px"
      size="small"
    >
      <el-form-item label="已选择" v-if="model.selected_drills">
        <div>
          <el-tag
            size="small"
            class="mr-5"
            v-for="item in model.selected_drills"
            :key="item.id"
            >{{ item.serial_number }}</el-tag
          >
        </div>
      </el-form-item>
      <el-form-item label="出库类型" prop="stock_out_category">
        <el-select v-model="model.stock_out_category" style="width: 100%">
          <el-option
            v-for="(value, index) in DrillStockOutCategoryMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="收货仓库"
        prop="stock_out_stockroom_id"
        v-if="model.stock_out_category == 1"
      >
        <el-select v-model="model.stock_out_stockroom_id" style="width: 100%">
          <el-option
            v-for="item in stockrooms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="井号"
        prop="stock_out_pit_number"
        v-if="model.stock_out_category == 2"
      >
        <el-input v-model="model.stock_out_pit_number"></el-input>
      </el-form-item>
      <el-form-item label="物流公司" prop="logistic_company">
        <ShipperSelect v-model="model.logistic_company"></ShipperSelect>
      </el-form-item>
      <el-form-item label="物流单号" prop="logistic_number">
        <el-input
          placeholder="物流单号"
          v-model="model.logistic_number"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="收件人手机号" prop="receiver_mobile">
        <el-input
          placeholder="使用顺丰时必填"
          v-model="model.receiver_mobile"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="备注" prop="stock_out_remark">
        <el-input v-model="model.stock_out_remark" type="textarea"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        :loading="loading"
        type="primary"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  drillRecordStockOut,
  drillRecordBatchStockOut,
  stockroomList,
} from '@/service/getData'
import { DrillStockOutCategoryMap } from '@/config/global'
import ShipperSelect from '@/components/select/shipper_select'

export default {
  components: {
    ShipperSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  created() {
    this.getStockrooms()
  },
  data() {
    return {
      DrillStockOutCategoryMap,
      visible: this.show,
      loading: false,
      rules: {
        stock_out_category: [{ required: true, message: '请选择出库类型' }],
        stock_out_stockroom_id: [{ required: true, message: '请选择收货仓库' }],
      },
      stockrooms: [],
    }
  },
  methods: {
    async getStockrooms() {
      let res = await stockroomList()
      if (res.status == 0) {
        this.stockrooms = res.data.list
      }
    },
    submitForm() {
      if (this.loading) {
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          let data = this.model
          if (this.model.id > 0) {
            let res = await drillRecordStockOut(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await drillRecordBatchStockOut(data)
            if (res.status == 0) {
              this.$emit('updated', res)
            }
          }
          this.loading = false
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>